import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { spacing } from 'ui/theme/utils';

export const Logo = ({ link, onClick, ...rest }) => {
  const history = useHistory();

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    history.push(link);
  };

  return <Image {...rest} cursor={link ? 'pointer' : 'inherit'} onClick={handleClick} />;
};

const Image = styled.img.attrs(({ variant }) => ({
  src: variant === 'white' ? '/api/v1/branding/logo' : '/assets/img/logo.png',
  alt: 'logo',
}))`
  width: ${({ width = '150px' }) => width};
  cursor: ${({ cursor = 'auto' }) => cursor};
  ${(props) => spacing(props)}
`;
